import axios from 'axios';

export const getHandshake = async (store) => {
  try {
    const res = await axios.post(
      `${process.env.NEXT_PUBLIC_API_BASEURL}/handshake/setCookiesToken`,
      { store },
      {
        withCredentials: true,
      }
    );
    const setCookieHeader = res.headers['set-cookie'] || [];

    const handshakeCookie = setCookieHeader.find((c) =>
      c.startsWith('handshake_token=')
    );

    if (!handshakeCookie) {
      throw new Error('Handshake token not found in response cookies.');
    }

    const token = handshakeCookie.split(';')[0].split('=')[1];
    return { token };
  } catch (error) {
    console.error('Handshake error:', error?.message || error);
    return error;
  }
};

export async function getServerHandshake() {
  const { cookies } = require('next/headers');
  const cookieStore = await cookies();
  const locale = cookieStore.get('NEXT_LOCALE')?.value || 'ar';
  const handshake = cookieStore.get(`phst_${locale}`)?.value;

  if (handshake) return handshake;

  return (await getHandshake(locale))?.token;
}

export const gethandshakeApiRoute = async (locale) => {
  let data = JSON.stringify({
    store: locale,
  });
  const config = {
    method: 'GET',
    url: '/api/phst',
    data: { data },
  };

  try {
    const req = await axios(config);

    return req.data;
  } catch (error) {
    console.log('error', error);
    return null;
  }
};
